// Manage folders — ports app/(privado)/album/pastas/page.tsx.

import { Link } from "react-router";
import { Flourish } from "@/components/ui/Flourish";
import { GestaoAlbuns } from "@/components/album/GestaoAlbuns";
import { Consulta } from "@/components/ui/EstadoConsulta";
import { useTitle } from "@/components/ui/useTitle";
import { useAlbumsWithCounts } from "@/api/queries";

export function AlbumPastas() {
  useTitle("As pastas");
  const query = useAlbumsWithCounts();

  return (
    <main className="mx-auto max-w-xl px-6 py-16">
      <header className="text-center">
        <p className="font-display text-lg italic text-ouro-600">Arrumar o baú</p>
        <h1 className="mt-2 font-display text-4xl text-tinta">As nossas pastas</h1>
        <div className="my-6">
          <Flourish />
        </div>
      </header>

      <Consulta query={query} linhas={2}>
        {(albuns) => <GestaoAlbuns albuns={albuns} />}
      </Consulta>

      <div className="mt-10 text-center">
        <Link
          to="/album"
          className="text-sm text-ouro-600 underline-offset-4 transition-colors hover:text-ouro hover:underline"
        >
          ← Voltar ao álbum
        </Link>
      </div>
    </main>
  );
}
